import React from 'react';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import LogoIcon from 'components/logo/LogoIcon';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// ==============================|| DRAWER HEADER ||============================== //

interface DrawerHeaderProps {
  open: boolean;
}

// DrawerHeader/index.tsx — now just a blank spacer
const DrawerHeader: React.FC = () => {
  return <DrawerHeaderStyled />;
};
export default DrawerHeader;
